import { below, media, widthBreakpoints } from 'src/config/breakpoints';
import { MediaQuery } from 'src/common/migration/MediaQuery';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { JoinElearningButton } from 'src/public/components/elearning/JoinElearningButton';
import { layers } from 'src/config/layers';
import { Elearning } from 'src/common/models/elearning';

const Container = styled.div`
  bottom: 0;
  left: 50%;
  padding: 0.75rem;
  max-width: 100%;
  position: fixed;
  transform: translate3d(-50%, 0, 0);
  width: 22.5rem;
  z-index: ${layers.widget};
  -webkit-backface-visibility: hidden;

  ${media.w.min.px768(css`
    display: none;
  `)};
`;

const StyledStartElearningButton = styled(JoinElearningButton)`
  width: 100%;
  max-width: 450px;
  align-self: center;
`;

export interface ElearningButtonWidgetProps {
  elearning: Elearning;
}

export const ElearningButtonWidget: FC<ElearningButtonWidgetProps> = ({ elearning }) => {
  return (
    <MediaQuery maxWidth={below(widthBreakpoints.px768)}>
      <Container>
        <StyledStartElearningButton elearning={elearning} />
      </Container>
    </MediaQuery>
  );
};
